window.Mailjet = {
	loadPrefs : function(){
		window.sellsyapp.$store.state.popupPanel.popupMailjetSettings.props = { mode: 'settings' }
		window.sellsyapp.$store.state.popupPanel.popupMailjetSettings.display = true
	},
};